import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'
import Accordion from '../../../../UI/Accordion/Accordion'
import ParticipationRate from './ParticipationRate/ParticipationRate'

const Info = () => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const items = [
    {
      key: 'info',
      title: t.survey.analysis.info.headline,
      content: <ParticipationRate />,
    },
  ]

  return <Accordion items={items} />
}

export default Info
